"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactLottie = _interopRequireDefault(require("./assets/react-lottie"));

var animationData = _interopRequireWildcard(require("./assets/data.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Loader = /*#__PURE__*/function (_Component) {
  _inherits(Loader, _Component);

  var _super = _createSuper(Loader);

  function Loader(props) {
    var _this;

    _classCallCheck(this, Loader);

    _this = _super.call(this, props);
    _this.state = {
      isAnimating: false,
      stopRequested: false,
      showSecondMotion: false
    };
    _this.stopAnimation = _this.stopAnimation.bind(_assertThisInitialized(_this));
    _this.startAnimation = _this.startAnimation.bind(_assertThisInitialized(_this));
    _this.completeIndicator = _this.completeIndicator.bind(_assertThisInitialized(_this));
    _this.secondCompleteIndicator = _this.secondCompleteIndicator.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Loader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.toggleAnimation) {
        this.startAnimation();
      } else {
        this.stopAnimation();
      }
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.playerOptions = {
        loop: true,
        autoplay: false,
        animationData: this.props.animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      }; //check for second ending motion

      if (this.props.secondData) {
        this.secondPlayerOptions = {
          loop: false,
          autoplay: false,
          animationData: this.props.secondData,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
          }
        };
      }
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(prevProps) {
      // update src file if changed
      this.playerOptions.animationData = this.props.animationData;

      if (this.props.secondData) {
        this.secondPlayerOptions.animationData = this.props.secondData;
      } // toggle the animation


      if (prevProps.toggleAnimation == this.props.toggleAnimation) {
        return;
      } else {
        if (this.props.toggleAnimation) {
          this.startAnimation();
        } else {
          this.stopAnimation();
        }
      }
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      // console.log('stopAnimation');
      this.setState({
        stopRequested: true
      });
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      // console.log('startAnimation');
      this.setState({
        stopRequested: false
      });

      if (this.state.isAnimating) {
        return;
      } else {
        this.setState({
          isAnimating: true
        });
      }
    } //this function is triggered by the lottie component, it is triggered at the end of each loop.

  }, {
    key: "completeIndicator",
    value: function completeIndicator() {
      // console.log('the animation completed:')
      if (this.state.stopRequested) {
        this.setState({
          isAnimating: false
        }); //check if there is another ending secondAnimationDuration

        if (this.props.secondData) {
          this.setState({
            showSecondMotion: true
          });
        }
      }

      if (this.props.completeIndicator) {
        this.props.completeIndicator();
      }
    } // triggered by the second loader

  }, {
    key: "secondCompleteIndicator",
    value: function secondCompleteIndicator() {
      console.log("secondCompleteIndicator");

      if (this.props.secondCompleteIndicator) {
        this.props.secondCompleteIndicator();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var s = this.state;
      var p = this.props; //check for the second animation trigger: it shows the first original loader then it shows the ending animation

      if (!s.showSecondMotion || s.isAnimating) {
        if (p.animationData) return /*#__PURE__*/_react["default"].createElement(_reactLottie["default"], {
          options: this.playerOptions,
          speed: p.dataDuration / parseFloat(p.duration),
          isPaused: !s.isAnimating,
          isStopped: !s.isAnimating,
          isClickToPauseDisabled: true,
          eventListeners: [{
            eventName: "loopComplete",
            callback: function callback() {
              return _this2.completeIndicator();
            }
          }]
        });else return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
      } else {
        if (p.secondData) return /*#__PURE__*/_react["default"].createElement(_reactLottie["default"], {
          options: this.secondPlayerOptions,
          isStopped: false,
          speed: p.secondDataDuration / parseFloat(p.secondDuration),
          isClickToPauseDisabled: true,
          eventListeners: [{
            eventName: "loopComplete",
            callback: function callback() {
              return _this2.secondCompleteIndicator();
            }
          }]
        });else return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
      }
    }
  }]);

  return Loader;
}(_react.Component);

Loader.defaultProps = {
  toggleAnimation: false,
  duration: 10.0,
  dataDuration: 10.0,
  animationData: animationData,
  completeIndicator: null,
  secondCompleteIndicator: null,
  secondData: null,
  secondDuration: 10.0,
  secondDataDuration: 10.0
};
var _default = Loader;
exports["default"] = _default;